import {
  AllowedHttpMethods,
  projectClosureRequestApiConfig,
} from '../../../../apiList'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../../utils/apiUtils'
import {
  ProjectClosureChecklistItem,
  addProjectClosureChecklist as AddProjectClosureChecklistType,
  ProjectClosureChecklistResponse,
  ChangeRequestProps,
  UpdateChecklistRequest,
  ProjectClosureResponse,
} from '../../../../../../types/ProjectManagement/Project/ProjectView/ProjectClosure/projectClosureChecklistTypes'

export const getProjectAllClosureChecklists = async (
  props: ChangeRequestProps,
): Promise<ProjectClosureChecklistResponse[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectClosureRequestApiConfig.getAllCheckLists,
    method: AllowedHttpMethods.get,
    params: {
      projectId: props.projectId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}
export const getProjectClosureChecklist = async (): Promise<
  ProjectClosureChecklistItem[]
> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectClosureRequestApiConfig.getCheckList,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

export const addProjectClosureChecklist = async (
  addProjectClosureDetails: AddProjectClosureChecklistType,
): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectClosureRequestApiConfig.addCheckList,
    method: AllowedHttpMethods.post,
    data: addProjectClosureDetails,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

export const getProjectClosureRequest = async (
  props: ChangeRequestProps,
): Promise<ProjectClosureChecklistItem[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectClosureRequestApiConfig.getProjectCheckList,
    method: AllowedHttpMethods.get,
    params: {
      id: props.id,
      projectId: props.projectId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

export const getPermissionsOfProjectClosure = async (
  projectId: string,
): Promise<string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectClosureRequestApiConfig.getPermissions,
    method: AllowedHttpMethods.get,
    params: {
      projectId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

export const updateProjectClosureChecklist = async (
  props: UpdateChecklistRequest,
): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectClosureRequestApiConfig.updateCheckList,
    method: AllowedHttpMethods.post,
    data: props,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

export const projectClosureHistoryDetails = async (
  id: string,
): Promise<ProjectClosureResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectClosureRequestApiConfig.getClosureHistory,
    method: AllowedHttpMethods.get,
    params: {
      id,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

export const uploadProjectClosureFile = async (
  file: File,
  id: number,
): Promise<number | undefined> => {
  const formData = new FormData()
  formData.append('file', file)

  const requestConfig = getAuthenticatedRequestConfig({
    url: projectClosureRequestApiConfig.uploadFiles,
    method: AllowedHttpMethods.post,
    data: formData,
    params: { id },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

export const getProjectClosureUploadFile = async (
  id: number,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectClosureRequestApiConfig.getUploadFiles,
    method: AllowedHttpMethods.get,
    params: {
      id,
    },
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}

export const getIsClosureEnable = async (
  projectId: string,
): Promise<boolean> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectClosureRequestApiConfig.getIsClosureEnable,
    method: AllowedHttpMethods.get,
    params: {
      projectId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const projectClosureChecklistApi = {
  getProjectClosureChecklist,
  addProjectClosureChecklist,
  getProjectClosureRequest,
  getPermissionsOfProjectClosure,
  getProjectAllClosureChecklists,
  updateProjectClosureChecklist,
  projectClosureHistoryDetails,
  getProjectClosureUploadFile,
  uploadProjectClosureFile,
  getIsClosureEnable,
}
export default projectClosureChecklistApi
